import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateSyncTableState = (id: number, data: { batchSize: number; isActive: boolean }): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpdateSyncTableState}/${id}`,
        method: RequestType.PUT,
        data,
    });

const SyncTableStateCommand = {
    UpdateSyncTableState,
};

export default SyncTableStateCommand;
